module.exports = "h1, h2, h3, h4 {\r\n\tfont-family: inherit;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/weekly-dashboard/weekly-dashboard.component.css
// module id = ./src/app/components/admin/weekly-dashboard/weekly-dashboard.component.css
// module chunks = main